import { fetchQrcode, fetchBarcode } from '@apis/barcodeApis';
import { useQuery } from '@hooks/useQuery';

export const useBarcode = (d2dNo: string) => {
  return useQuery(['/label/barcode', d2dNo], async () => fetchBarcode(d2dNo));
};

export const useQrcode = (d2dNo: string) => {
  return useQuery(['/label/qrcode', d2dNo], async () => fetchQrcode(d2dNo));
};
